import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const Banners = async () => {
  try {
    return await getData(`/website/homepage/homebanner`);
  } catch (error) {
    console.log(error);
  }
};

export const FreeConsultations = async (data) => {
  try {
    return await postData(`/website/freeconsultation/add`, data);
  } catch (error) {
    console.log(error);
  }
};
 

export const ConsultationTypes = async () => {
try{
    return await getData("/website/freeconsultation/consultation-types");
}
catch (error) {
    console.log(error);
  }
};


export const AvgMonthlyBills = async () => {
  try {
    return await getData("/website/freeconsultation/avg-monthly-bills");
  }
  catch (error) {
    console.log(error);
  }
};


export const Customers = async () => {
  try {
    return await getData(`/website/aboutus/whatourclientsay`);
  } catch (error) {
    console.log(error);
  }
};

export const TrustedCommunitys = async () => {
  try {
    return await getData(`/website/homepage/trustedacrosscommunity`);
  } catch (error) {
    console.log(error);
  }
};

export const SolarPowers = async () => {
  try {
    return await getData(`/website/homepage/everyspace`);
  } catch (error) {
    console.log(error);
  }
};

export const SolarInsights = async () => {
  try {
    return await getData(`/website/homepage/blog`);
  } catch (error) {
    console.log(error);
  }
};

export const PowerProgress = async () => {
  try {
    return await getData(`/website/homepage/appsetup`);
  } catch (error) {
    console.log(error);
  }
};

// export const Power = async () => {
//   try {
//     return await getData(`/website/powerprogress/powerprogress`);

//   } catch (error) {
//     console.log(error);
//   }
// };

export const Power = async () => {
  try {
    const res = await getData(`/website/powerprogress/powerprogress`);
    // console.log("Raw Power API Response:", res?.data); // <-- this will show the API data
    return res;
  } catch (error) {
    console.log("Power API Error:", error);
  }
};